import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { MatrixSettings } from "../../../shared/lib/types/matrix-task-model/matrix-task-model"

type MatrixInitial = {
    entities: MatrixSettings
}

export const initialState: MatrixInitial = {
    entities: {
        isActive: false,
        variantView: 0,
        listTaskIsHide: false,
        fetchVariant: 'Today'
    }
}

export const matrixSlice = createSlice({
    name: 'matrix',
    initialState: initialState,
    selectors: {
        getMatrixVariantView: (state) => state.entities.variantView,
        getIsOpenMatrix: (state) => state.entities.isActive,
        getListTaskPosition: (state) => state.entities.listTaskIsHide,
        getFetchVariant: (state) => state.entities.fetchVariant
    },
    reducers: {
        setMatrixVariantView: (state, action: PayloadAction<{variant: number}>) => {
            state.entities.variantView = action.payload.variant
        },
        setMatrix: (state, action: PayloadAction<{isActive: boolean}>) => {
            state.entities.isActive = action.payload.isActive
        },
        setListTaskPosition: (state, action: PayloadAction<{isHide: boolean}>) => {
            state.entities.listTaskIsHide = action.payload.isHide
        },
        setFetchVariant: (state, action: PayloadAction<{fetch: 'Today' | 'Incoming'}>) => {
            state.entities.fetchVariant = action.payload.fetch
        }
    }

})